export default function getResource(label, vars = []) {
    const resources = {
        bpRedesignSubtitle: `En fonction des ${vars[0]} caractéristiques et préférences choisies.`,
        confettiModalTitleOneWorld: ' Bien joué! Continuez 🎉',
        confettiModalMessageOneWorld: 'Plus vous ajoutez de préférences, plus vous aurez de suggestions d’essentiels.',
        confettiModalTitleAllWords: ' Tout est fait! 🎉',
        confettiModalMessageAllWords: 'Vous avez bien défini vos préférences beauté pour votre profil. Vous pouvez maintenant profiter de recommandations personnalisées.',
        gotIt: 'Compris',
        privacySettings: 'Paramètres de confidentialité des préférences beauté',
        changesNotSavedModalTitle: 'Modifications non enregistrées',
        changesNotSavedModalBody: 'Un problème est survenu lors du traitement de votre soumission. Veuillez essayer de nouveau.',
        viewAll: 'Voir tout'
    };
    return resources[label];
}
